import React, { useState } from 'react';
import { FileUpload } from '../../ui/FileUpload';
import { Button } from '../../ui/Button';
import { ArrowRight } from 'lucide-react';
interface IdUploadScreenProps {
  onNext: (file: File) => void;
  initialFile?: File | null;
}
export function IdUploadScreen({
  onNext,
  initialFile
}: IdUploadScreenProps) {
  const [file, setFile] = useState<File | null>(initialFile || null);
  return <div className="flex flex-col h-full animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-177">
      <div className="flex-1" data-id="element-178">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-179">
          Upload Identification
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-180">
          Please upload a valid government-issued ID (Passport, Driver's
          License, or National ID).
        </p>

        <div className="max-w-xl" data-id="element-181">
          <FileUpload label="Identity Document" accept=".pdf,.jpg,.jpeg,.png" onChange={file => setFile(file)} value={file} data-id="element-182" />
        </div>
      </div>

      <div className="mt-8 flex justify-end" data-id="element-183">
        <Button onClick={() => file && onNext(file)} disabled={!file} className="w-full sm:w-auto" data-id="element-184">
          Next Step <ArrowRight className="ml-2 h-4 w-4" data-id="element-185" />
        </Button>
      </div>
    </div>;
}